import React from "react";
import { registerOverlay } from "../overlays";

// Must stay in step with getActiveAct in scrollMath.js.
const LABELS = ["Intro", "Noise", "Product", "Promise", "Calm"];

export default function ProgressRail() {
  return (
    <div className="fixed right-6 top-1/2 -translate-y-1/2 z-40 hidden lg:flex flex-col items-center gap-4">
      {LABELS.map((label, i) => (
        <div key={i} className="flex items-center gap-3 group" title={label}>
          <span
            ref={(el) => registerOverlay(`rail-${i}`, el)}
            style={{
              width: 3,
              height: 10,
              borderRadius: 999,
              background: "rgba(10,10,10,0.35)",
              transition: "height 0.4s var(--ease-out), opacity 0.4s, background 0.4s",
              display: "block",
            }}
          />
        </div>
      ))}
    </div>
  );
}
